import { css } from 'styled-components';
import { cssColorsFromBackgroundField } from './background';
import { breakpoints } from './breakpoints';
import { colorCSS } from './colors';
import { gradientExists, gradients } from './gradients';
export function generateFieldsStyles(fields) {
    return fields.reduce((styles, field) => {
        return css `
      ${styles}
      ${generateFieldStyles(field)}
    `;
    }, css ``);
}
export function generateFieldStyles(field) {
    return field.breakpoints.reduce((styles, breakpoint) => {
        if (breakpoint === 'xs') {
            styles = css `
          ${styles}
          ${generateBreakpoint(field.color, field.properties, breakpoints.xs, breakpoints.sm)}
        `;
        }
        if (breakpoint === 'sm') {
            styles = css `
          ${styles}
          ${generateBreakpoint(field.color, field.properties, breakpoints.sm, breakpoints.md)}
        `;
        }
        if (breakpoint === 'md') {
            styles = css `
          ${styles}
          ${generateBreakpoint(field.color, field.properties, breakpoints.md, breakpoints.lg)}
        `;
        }
        if (breakpoint === 'lg') {
            styles = css `
          ${styles}
          ${generateBreakpoint(field.color, field.properties, breakpoints.lg, breakpoints.xl)}
        `;
        }
        if (breakpoint === 'xl') {
            styles = css `
          ${styles}
          ${generateBreakpoint(field.color, field.properties, breakpoints.xl)}
        `;
        }
        return styles;
    }, css ``);
}
export function generateBreakpoint(color, propertiesArr, lower, upper) {
    return css `
    @media ${createMediaQuery(lower, upper)} {
      ${createBackground(color, propertiesArr)}
    }
  `;
}
export function createMediaQuery(lower, upper) {
    if (upper) {
        return `(min-width: ${lower}px) and (max-width: ${upper - 1}px)`;
    }
    else {
        return `(min-width: ${lower}px)`;
    }
}
export function createBackground(color, propertiesArr) {
    if (!propertiesArr.length) {
        return css `
      ${createTextColor(color)}
    `;
    }
    else {
        return css `
      ${createBackgroundProperties(propertiesArr)}
      ${createTextColor(color)}
    `;
    }
}
export function createBackgroundProperties(propertiesArr) {
    return css `
    background-attachment: ${generateAttachment(propertiesArr)};
    background-blend-mode: ${generateBlendMode(propertiesArr)};
    background-clip: ${generateClip(propertiesArr)};
    background-image: ${generateImage(propertiesArr)};
    background-origin: ${generateOrigin(propertiesArr)};
    background-position: ${generatePosition(propertiesArr)};
    background-repeat: ${generateRepeat(propertiesArr)};
    background-size: ${generateSize(propertiesArr)};
  `;
}
export function createTextColor(color) {
    return color === 'transparent'
        ? css `
        background-color: transparent;
      `
        : cssColorsFromBackgroundField({ color });
}
export function generateAttachment(propertiesArr) {
    return propertiesArr.map((properties) => properties.attachment).join(', ');
}
export function generateBlendMode(propertiesArr) {
    return propertiesArr.map((properties) => properties.blendMode).join(', ');
}
export function generateClip(propertiesArr) {
    return propertiesArr.map((properties) => properties.clip).join(', ');
}
export function generateImage(propertiesArr) {
    return propertiesArr
        .map((properties) => convertImageToValue(properties.image))
        .join(', ');
}
export function generateOrigin(propertiesArr) {
    return propertiesArr.map((properties) => properties.origin).join(', ');
}
export function generateRepeat(propertiesArr) {
    return propertiesArr.map((properties) => properties.repeat).join(', ');
}
export function generateSize(propertiesArr) {
    return propertiesArr
        .map((properties) => convertSizeToValue(properties.size))
        .join(', ');
}
export function generatePosition(propertiesArr) {
    return propertiesArr
        .map((properties) => convertPositionToValue(properties.position))
        .join(', ');
}
export function convertImageToValue(image) {
    if (image.type === 'image') {
        if (image.image.value === 'none') {
            return 'none';
        }
        else {
            return `url("${image.image.value}")`;
        }
    }
    else {
        return convertGradientToValue(image.gradient.value, image.gradient.angle);
    }
}
export function convertPositionToValue(position) {
    if (position.fieldType === 'keywords') {
        return `${position.keywords.horizontal} ${position.keywords.vertical}`;
    }
    else {
        return `${position.units.horizontal}${position.units.unit} ${position.units.vertical}${position.units.unit}`;
    }
}
export function convertSizeToValue(size) {
    if (size.fieldType === 'keyword') {
        return size.keyword;
    }
    else {
        const width = size.units.isAutoWidth
            ? 'auto'
            : `${size.units.width}${size.units.unit}`;
        const height = size.units.isAutoHeight
            ? 'auto'
            : `${size.units.height}${size.units.unit}`;
        return `${width} ${height}`;
    }
}
export function convertGradientToValue(gradientId, angle) {
    if (gradientExists(gradientId)) {
        const cssForStops = gradients[gradientId].colors
            .map((colorId) => colorCSS(colorId))
            .join(',');
        return `linear-gradient(${angle}deg, ${cssForStops})`;
    }
    else {
        return 'none';
    }
}
//# sourceMappingURL=background-field-styles.js.map